<template>
  <!-- 资料详细页 -->
  <!-- 版心 -->
  <div class="information-detail-container">
    <!-- 左边详情 start -->
    <div class="information-LeftDetail fl">
      <!-- 左边详情的上面 start -->
      <div class="information-LeftDetail-top">
        <div class="information-LeftDetail-top1">
          <h3>{{ detailList.title }}</h3>
          <p>
            {{ timestampToTime(detailList.createTime) }}
            <span>上传</span>
          </p>
          <img :src="detailList.cover" alt />
        </div>
        <div class="information-LeftDetail-top2">
          <span style="margin-right:20px">
            文件类型:
            <span>{{detailList.type}}</span>
          </span>
          <span style="margin-right:20px">
            浏览量:
            <span>{{ detailList.views }}</span>
          </span>
          <span style="margin-right:20px">
            文件大小:
            <span>{{ detailList.size }}MB</span>
          </span>
          <span>
            下载次数:
            <span>{{ detailList.downloads }}</span>
          </span>
        </div>
        <div class="information-LeftDetail-top3">
          <div
            class="collectBox"
            v-if="detailList.isAttention == false"
            @click="btnCollection(detailList)"
          >
            <i class="iconfont icon-shoucang"></i>收藏
          </div>
          <div class="collectBox" v-else @click="btnCollectioned(detailList)">
            <i class="iconfont icon-shoucangxuanzhong"></i>已收藏
          </div>
          <div class="share fr" style="position:relative">
            <div @click.stop="shareFn">
              <i class="iconfont icon-fenxiang"></i>分享
            </div>
            <div
              style="position:fixed;top:0;left:0;width:100vw;height:100vh; opacity:0; z-index:0"
              v-show="shareBox"
              @click.stop="shareBox=false"
            ></div>
            <div class="share_box" v-show="shareBox">
              <ul class="share-ways">
                <li class="share-QQ" @mouseenter="qqFn1" @mouseleave="qqFn2" @click="qqUrl">
                  <img :src="img" class="qq-img" />
                </li>
                <li class="share-wechat" @mouseenter="wechatFn1" @mouseleave="wechatFn2">
                  <img :src="pic" class="weixin-img" />
                  <div class="share_wechat_ercodebox" v-show="wechatBox">
                    <div class="share-wechat-ercode" ref="qrCodeUrls">
                      <!-- <div
                        id="qrcode"
                        ref="qrcode"
                      ></div>
                      <img
                        src=""
                        alt=""
                      >-->
                    </div>
                    <div class="arrow-down arrow-down-out"></div>
                    <div class="arrow arrow-out"></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="information-LeftDetail-top4">
          <el-button class="information-LeftDetail-btn1" style="color:#fff" @click="downloadsFn()">
            {{ detailList.integral }}
            积分下载
          </el-button>
          <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
            <span class="dialog-topic" slot="title">{{ detailList.title }}{{ detailList.type }}</span>
            <div class="dialog-body">
              <span></span>
              <b></b>
              <div class="dialog-content">
                <div class="dialog-need">
                  <p class="one">资源所需积分</p>
                  <p class="two">{{detailList.integral}}</p>
                </div>
                <div class="dialog-need">
                  <p class="one">资源所需服务积分</p>
                  <p class="two">1</p>
                </div>
                <div class="dialog-possess">
                  <p class="one">当前拥有积分</p>
                  <p class="two">{{ userList.integral }}</p>
                </div>
                <div class="dialog-surplus">
                  <p class="one">购买剩余积分</p>
                  <p class="two">{{userList.integral - detailList.integral-1}}</p>
                </div>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <span class="dialog-tips fl" v-if="userList.integral < detailList.integral">积分不足!</span>
              <el-button
                @click="integralFn()"
                class="dialog-integral"
                :disabled="userList.integral < detailList.integral "
              >积分下载</el-button>
            </span>
          </el-dialog>
          <!-- <el-button class="information-LeftDetail-btn2" style="color: #333;" @click="goVIP">VIP免费下载</el-button> -->
        </div>
      </div>
      <!-- 左边详情的上面 end -->
      <!-- 左边详情的中间 start -->
      <div class="information-LeftDetail-middle">
        <div class="information-LeftDetail-middleTop">资料推荐</div>
        <ul class="information-LeftDetail-middleContent">
          <el-empty v-if="searchList.records && !searchList.records.length" description="暂无数据"></el-empty>
          <li
            class="fl"
            style="margin-top:0px"
            v-for="(d,index) in searchList.records"
            :key="index"
            @click="goInformationDetail(d)"
          >
            <img :src="d.cover" class="fl" />
            <div class="LeftDetail-middleContent1 fl">
              <h4 class="fl">{{ d.title }}</h4>
              <span style="color: #676c71;margin-right:2px">分享工匠</span>
              <span v-if="d.nickName != null">{{ d.nickName }}</span>
              <span v-else>ing</span>
              <p>
                行业分类:
                <em style="color: #333;">{{ d.industryType }}</em>
              </p>
            </div>
            <div class="LeftDetail-middleContent2 fr">
              <p class="fl" style="width:120px;margin-right:10px">
                浏览次数:
                <span v-if="d.views >10000">{{ d.views/10000 }}w</span>
                <span v-else>{{ d.views }}</span>
              </p>
              <p class="fl" style="margin-right:10px">
                上传时间:
                <span>{{ timestampToTime(d.auditTime) }}</span>
              </p>
              <p class="fl" style="width:65px;margin-right:10px">
                <span style="color: #ee9c3f;" v-if="d.integral !=0">积分:{{ d.integral }}</span>
                <span style="color: #ee9c3f;" v-else>免费</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 左边详情的中间 end -->

      <!-- 推荐模块start -->
      <div class="recommend-mode">
        <h4>模板推荐</h4>
        <strong></strong>
      </div>
      <ul class="recommend">
        <li class="fl" v-for="(t ,index) in templateList" :key="index" @click="goInformationTwo(t)">
          <img v-if="t.cover !== null" :src="image" />
          {{t.title}}
        </li>
      </ul>
      <!-- 推荐模块end -->
    </div>
    <!-- 左边详情 end -->
    <!-- 右边详情 start -->
    <div class="information-Rightdetail fr">
      <!-- 右边详情的第一行 start -->
      <div class="information-Rightdetail-one">
        <img :src="lecturerList.picture" />
        <div class="information-Rightdetail-nickname">
          <h6>{{ lecturerList.nickName }}</h6>
          <span style="margin-right:10px">
            粉丝:
            <span>{{ lecturerList.fans }}</span>
          </span>
          <span>
            资源:
            <span style="color:#3274f6">{{ lecturerList.resources }}</span>
          </span>
        </div>
        <el-button
          style="color:#fff"
          class="follow-btn"
          @click="btnFollow(lecturerList)"
          v-if="lecturerList.isAttention == false"
        >关注</el-button>
        <el-button v-else class="followed-btn" @click="btnFollowed(lecturerList)">已关注</el-button>
      </div>
      <!-- 右边详情的第一行 end -->
      <!-- 右边详情的第二行 start -->
      <div class="information-Rightdetail-two">
        <div class="upload-document-information">
          <img src="../uploads/findinformation file.png" alt class="fl" />
          <p class="fl">
            已有
            <span>超过100000</span>会员上传并分享了文档，你的文档在哪里？
          </p>
          <el-button class="upload-document-points" @click="goDocument">上传文档获取积分</el-button>
        </div>
      </div>
      <!-- 右边详情的第二行 end -->
      <!-- 右边详情的第三行 start -->
      <div class="information-Rightdetail-three">
        <div class="hot-courses-information fl">
          <h4>课程推荐</h4>
          <span></span>
          <CourseTemplate />
        </div>
      </div>
      <!-- 右边详情的第三行 end -->
      <!-- 右边详情的第四行 start -->
      <div class="information-Rightdetail-four">
        <div class="hot-search fl">
          <p class="hot-search-word fl">会议推荐</p>
          <strong></strong>
        </div>
        <ul class="latest-upload fl">
          <el-empty v-if="meetingList && !meetingList.length" description="暂无数据"></el-empty>
          <li
            v-for="(meeting,index) in meetingList"
            :key="index"
            @click="goMeetingDeatils(meeting)"
          >
            <div class="point fl"></div>
            <p>{{ meeting.title }}</p>
          </li>
        </ul>
      </div>
      <!-- 右边详情的第四行 end -->
      <!--  右边详情的第五行 start -->
      <div class="information-Rightdetail-five">
        <div class="hot-search fl">
          <p class="hot-search-word fl">资讯推荐</p>
          <strong></strong>
        </div>
        <ul class="latest-upload fl">
          <el-empty v-if="newsList.records && !newsList.records.length" description="暂无数据"></el-empty>
          <li v-for="(news,index) in newsList.records" :key="index" @click="goNewsDeatils(news)">
            <div class="point fl"></div>
            <p>{{ news.messageTitle }}</p>
          </li>
        </ul>
      </div>
      <!-- 右边详情的第五行 end -->
    </div>
    <!-- 右边详情 end -->
  </div>
</template>

<script>
import { detailMessage, courseInfo } from "@/api/common";
import {
  downloadDocument,
  collection,
  cancelCollection,
  searchDocument,
  templateRecommend
} from "@/api/data/index";
import { cancel, concern } from "@/api/teacher/index";
import { getUserInfo } from "@/api/user/userinfo";
import { getPageByType } from "@/api/news/index";
import { hotTopic } from "@/api/meeting/index";
import { toQQ } from "@/utils/share.js";
import QRCode from "qrcodejs2";
export default {
  name: "InformationDetail",
  data() {
    return {
      detailList: [], // 详细列表
      picList: [], // 图片列表
      downloadList: [], //  下载
      dialogVisible: false,
      // integralList: [], // 全部积分
      userList: [], // 个人信息列表
      lecturerList: [], // 讲师信息
      temporaryVar: null,
      searchList: [], //资料推荐
      templateList: [], // 模版推荐
      image:
        "https://zhongan-resource-test.oss-cn-beijing.aliyuncs.com/pic/PPT.png",
      type: "",
      meetingList: [], // 会议推荐
      newsList: [], // 资讯推荐
      shareBox: false, // 分享盒子
      wechatBox: false, // 微信二维码盒子
      imgObj: {
        imgOne: require("../../../assets/uploads/qqOne.png"),
        imgTwo: require("../../../assets/uploads/qqTwo.png")
      },
      img: require("../../../assets/uploads/qqOne.png"),
      picObj: {
        picOne: require("../../../assets/uploads/wechatOne.png"),
        picTwo: require("../../../assets/uploads/wechatTwo.png")
      },
      pic: require("../../../assets/uploads/wechatOne.png")
    };
  },
  mounted() {
    detailMessage(this.$route.query.id).then(res => {
      this.detailList = res.data;
      courseInfo(this.detailList.userId).then(res => {
        if (res.code == 200) {
          this.lecturerList = res.data;
        } else {
          const h = this.$createElement;
          this.$notify({
            message: h("i", { style: "color: red" }, res.message)
          });
        }
      });
    });
    // 模版推荐
    templateRecommend().then(res => {
      if (res.code == 200) {
        this.templateList = res.data;
      }
    });
    const data = {
      current: 1,
      size: 10,
      title: "",
      type: this.type,
      industryType: this.$route.query.industryType
    };
    // 资料推荐
    searchDocument(data).then(res => {
      this.searchList = res.data;
    });
    // 会议推荐
    hotTopic(data).then(res => {
      if (res.code == 200) {
        this.meetingList = res.data;
      }
    });
    // 资讯推荐   按行业类型查找分页
    getPageByType(data).then(res => {
      if (res.code == 200) {
        this.newsList = res.data;
        this.total = res.data.total;
      }
    });
  },
  methods: {
    // 点击分享按钮
    shareFn() {
      this.shareBox = true;
    },
    // qq
    qqFn1() {
      this.img = this.imgObj.imgTwo;
    },
    qqFn2() {
      this.img = this.imgObj.imgOne;
    },
    // 分享到QQ
    qqUrl() {
      let url = location.href;
      let title = "我是标题";
      toQQ(url, title);
    },
    // 微信
    wechatFn1() {
      this.pic = this.picObj.picTwo;
      this.wechatBox = true;
      // 分享到微信
      this.$nextTick(() => {
        var qrcodes = new QRCode(this.$refs.qrCodeUrls, {
          text: location.href, // 需要转换为二维码的内容
          width: 85,
          height: 85,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    wechatFn2() {
      this.pic = this.picObj.picOne;
      this.wechatBox = false;
      this.$refs.qrCodeUrls.innerHTML = "";
    },
    // 加收藏
    btnCollection(detailList) {
      console.log(detailList);
      collection(this.$route.query.id, 2).then(res => {
        // 没有收藏，就收藏
        this.$notify({
          title: "成功",
          message: "收藏成功！",
          type: "success"
        });
        detailList.isAttention = !detailList.isAttention;
      });
    },
    // 已收藏要取消收藏
    btnCollectioned(detailList) {
      console.log(detailList);

      // 已收藏要取消收藏
      cancelCollection(this.$route.query.id, 2).then(res => {
        this.$notify({
          title: "成功",
          message: "取消收藏成功！",
          type: "success"
        });
        detailList.isAttention = !detailList.isAttention;
      });
    },
    // 加关注
    btnFollow(lecturerList) {
      const data = {
        attentionId: this.detailList.userId
      };
      concern(data)
        .then(res => {
          // 没有关注，就添加关注
          this.$notify({
            title: "成功",
            message: "关注成功！",
            type: "success"
          });
          lecturerList.isAttention = !lecturerList.isAttention;
        })
        .catch(err => {
          let message = "操作失败,请重试！";
          if (err.response.status === 401) {
            message = "请登录后再试！";
          }
          this.$toast(message);
        });
    },
    // 已关注要取消关注
    btnFollowed(lecturerList) {
      const data = {
        attentionId: this.detailList.userId
      };
      cancel(data)
        .then(res => {
          this.$notify({
            title: "成功",
            message: "取消关注成功！",
            type: "success"
          });
          lecturerList.isAttention = !lecturerList.isAttention;
        })
        .catch(err => {
          let message = "操作失败,请重试！";
          if (err.response.status === 401) {
            message = "请登录后再试！";
          }
          this.$toast(message);
        });
    },

    downloadsFn() {
      // code400 积分不足
      this.dialogVisible = true;
      // 资源所需积分 detailList.integral
      // 当前拥有积分 userList.integral
      getUserInfo().then(res => {
        this.userList = res.data;
      });
    },
    integralFn() {
      downloadDocument(this.$route.query.id).then(res => {
        this.downloadList = res.data;
        if (res.data) {
          // console.log('record.httpAddress: ', record.httpAddress)
          const link = document.createElement("a");
          //_blank表示在新窗口打开链接
          link.target = "_blank";
          link.href = res.data;
          link.setAttribute("download", "文件名字" + Date.now() + ".jpg"); // 下载文件的名称及文件类型后缀
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
        }
      });
      this.dialogVisible = false;
    },
    goDocument() {
      this.$router.push({
        path: "/user/uploaddata"
      });
    },
    // 资料推荐去资料详情
    goInformationDetail(d) {
      detailMessage(d.id).then(res => {
        this.detailList = res.data;
      });
      this.$router.push({
        path:
          "/informationdetail?id=" + d.id + "&industryType=" + d.industryType
      });
    },
    // 模版推荐去资料详情
    goInformationTwo(t) {
      detailMessage(t.id).then(res => {
        this.detailList = res.data;
      });
      this.$router.push({
        path:
          "/informationdetail?id=" + t.id + "&industryType=" + t.industryType
      });
    },
    goNewsDeatils(news) {
      this.$router.push({
        path: "/newsdetails?id=" + news.id
      });
    },
    goMeetingDeatils(meeting) {
      this.$router.push({
        path:
          "/meetingdetails?id=" +
          meeting.id +
          "&industryType=" +
          meeting.industryType
      });
    },
    goVIP() {
      console.log(this.$store.state.user.userInfo.isVip);
      if (this.$store.state.user.userInfo.isVip == 1) {
        downloadDocument(this.$route.query.id).then(res => {
          this.downloadList = res.data;
          if (res.data) {
            // console.log('record.httpAddress: ', record.httpAddress)
            const link = document.createElement("a");
            //_blank表示在新窗口打开链接
            link.target = "_blank";
            link.href = res.data;
            link.setAttribute("download", "文件名字" + Date.now() + ".jpg"); // 下载文件的名称及文件类型后缀
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
          }
        });
      } else {
        this.$router.push({
          path: "/joinvip"
        });
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 时间戳转换为当前时间
    timestampToTime(date) {
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var date = new Date(date);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "年" + MM + "月" + d + "日" + h + ":" + m;
    }
  }
};
</script>

<style scoped>
/* 版心 */
.information-detail-container {
  width: 1200px;
  margin: 0 auto;
  height: 2000px;
}
/* 左边详情 start */
.information-LeftDetail {
  width: 779px;
  margin-top: 30px;
}
/* 左边详情的上面 start */
.information-LeftDetail .information-LeftDetail-top {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 30px;
  width: 779px;
  height: 300px;
  background-color: #fff;
}

/* 第一行 */
.information-LeftDetail-top1 {
  margin-left: 0px;
  position: relative;
  width: 510px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: wrap;
}
.information-LeftDetail-top1 h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
  color: #333;
}
.information-LeftDetail-top1 p {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 28px;
  color: #676c71;
}
.information-LeftDetail-top1 img {
  position: absolute;
  top: 0;
  right: -230px;
  width: 180px;
  height: 210px;
}
/* 第二行 */
.information-LeftDetail-top2 {
  margin-left: 0;
  width: 510px;
}
.information-LeftDetail-top2 span {
  color: #676c71;
  font-size: 14px;
  font-weight: 600;
}

/* 第三行 */
.information-LeftDetail-top3 {
  margin-top: 20px;
  margin-left: 0px;
  display: flex;
  width: 200px;
  height: 40px;
  line-height: 40px;
}

.information-LeftDetail-top3 .collectBox,
.information-LeftDetail-top3 .share {
  margin-left: 0px;
  color: #eb5139;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.information-LeftDetail-top3 i {
  font-size: 20px;
  font-weight: 400;
}
.information-LeftDetail-top3 .share {
  display: flex;
}

/* 分享盒子 */
.share_box {
  padding-left: 14px;
  width: 100px;
  height: 40px;
  line-height: 55px;
  border: 1px solid #eb5139;
  position: absolute;
  top: 0;
  left: 70px;
}

.share_box .share-ways {
  height: 40px;
}
.share-ways li {
  display: inline-block;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 10px;
  margin-bottom: 5px;
  text-align: center;
  cursor: pointer;
}
.share-ways li .qq-img,
.share-ways li .weixin-img {
  display: block;
  width: 28px;
  height: 28px;
}

.share-wechat {
  position: relative;
}
.share_wechat_ercodebox {
  position: absolute;
  top: -35px;
  right: -115px;
  width: 93px;
  height: 110px;
  background-color: transparent;
}
.share-wechat-ercode {
  position: relative;
  box-sizing: border-box;
  padding-top: 3px;
  width: 93px;
  height: 93px;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 2px;
  vertical-align: top;
}
/* .share-wechat-ercode img {
  width: 85px;
  height: 85px;
  vertical-align: top;
  margin-top: 4px;
} */
.share_box .arrow-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ccc;
  position: absolute;
}

.share_box .arrow-down-out {
  bottom: 52px;
  right: 93px;
}
.share_box .arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 11px solid #fff;
  position: absolute;
}
.share_box .arrow-out {
  bottom: 52px;
  right: 92px;
}

/* 第四行 */
.information-LeftDetail-top4 {
  margin-top: 10px;
  margin-left: 0px;
  width: 246px;
}
/* 积分兑换的弹出层 start */
.information-LeftDetail-top4 >>> .el-dialog {
  margin-top: 20vh !important;
  /* width: 45% !important;
  height: 50% !important; */
  width: 406px !important;
  height: 266px !important;
  background: #ffffff;
  border-radius: 2px 2px 2px 2px;
}
/* 标题区域内容 */
.information-LeftDetail-top4 >>> .el-dialog__header {
  padding-bottom: 0px !important;
  height: 40px;
  background: #fff;
}
.information-LeftDetail-top4 >>> .el-dialog__headerbtn {
  font-size: 22px !important;
  color: #6c6c6d;
}

/* 资源的名称 */
.information-LeftDetail-top4 >>> .dialog-topic {
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
/* 中间区域的内容 */
.information-LeftDetail-top4 >>> .el-dialog__body {
  padding: 20px !important;
  padding-top: 0px !important;
  height: auto !important;
}
.information-LeftDetail-top4 >>> .dialog-body {
  position: relative;
}
/* 横线一 */
.information-LeftDetail-top4 >>> .el-dialog__body span {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e5e5e5;
}
/* 横线二 */
.information-LeftDetail-top4 >>> .el-dialog__body b {
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e5e5e5;
}
.information-LeftDetail-top4 >>> .dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 10px;
  box-sizing: border-box;
  width: 366px;
  height: 160px;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #e5e5e5;
}
.information-LeftDetail-top4 >>> .one {
  flex: 1;
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.information-LeftDetail-top4 >>> .two {
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ee9c3f;
}
/* 所需积分 */
.information-LeftDetail-top4 >>> .dialog-need {
  width: 100%;
  display: flex;
}
.information-LeftDetail-top4 >>> .dialog-need::after {
  border: 1px solid #e5e5e5;
}
/* 拥有积分 */
.information-LeftDetail-top4 >>> .dialog-possess {
  width: 100%;
  display: flex;
}
/* 剩余积分 */
.information-LeftDetail-top4 >>> .dialog-surplus::before {
  border: 1px solid #e5e5e5;
}
.information-LeftDetail-top4 >>> .dialog-surplus {
  width: 100%;
  display: flex;
}
/* 积分兑换按钮 */
.information-LeftDetail-top4 >>> .dialog-integral {
  width: 127px;
  height: 32px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: -31px;
  background: #ed702e;
  border: 0;
}
/* 底部区域 */
.information-LeftDetail-top4 >>> .el-dialog__footer {
  padding-bottom: 0px !important;
}
.information-LeftDetail-top4 >>> .dialog-tips {
  line-height: 28px;
  font-size: 12px;
  color: #ff4444;
}
/* 积分兑换的弹出层 end */

/* 积分下载按钮 */
.information-LeftDetail-btn1 {
  margin-right: 20px;
  width: 112px;
  height: 40px;
  background: #eb5139;
  border-radius: 4px;
  border: 0;
}
/* 会员下载按钮 */
.information-LeftDetail-btn2 {
  width: 97px;
  height: 40px;
  font-weight: 600;
  background: #f4e4c7;
  border-radius: 4px;
  border: 0;
}
/* 左边详情的上面 end */
/* 左边详情的中间 start */
.information-LeftDetail .information-LeftDetail-middle {
  width: 779px;
  height: 986px;
  margin-top: 30px;
  overflow: hidden;
  background-color: #fff;
}
/* 上边的文字 */
.information-LeftDetail-middleTop {
  position: relative;
  height: 40px;
  margin: 30px;
  font-size: 16px;
  font-weight: 600;
  color: #eb5139;
}
/* 文字下面的横线 */
.information-LeftDetail-middleTop::after {
  margin-top: 4px;
  content: "";
  position: absolute;
  top: 30px;
  left: 3px;
  width: 60px;
  height: 5px;
  background: #eb5139;
}
/* 内容区域 */
.information-LeftDetail-middleContent {
  margin-left: 0px;
}
/* 下边的每一行 */
.information-LeftDetail-middleContent li {
  box-sizing: border-box;
  margin-left: 0;
  position: relative;
  margin: 20px 0;
  padding: 0 20px;
  width: 789px;
  height: 70px;
  cursor: pointer;
}
.information-LeftDetail-middleContent li::after {
  content: "";
  position: absolute;
  top: 73px;
  left: 0;
  width: 779px;
  height: 0px;
  border: 1px solid #e5e5e5;
}
.information-LeftDetail-middleContent li:nth-child(10)::after {
  width: 0;
}
.information-LeftDetail-middleContent li img {
  width: 45px;
  height: 55px;
}
/* 图片右边的文字 */
.LeftDetail-middleContent1 {
  margin-left: 18px;
  width: 280px;
}
.LeftDetail-middleContent1 h4 {
  margin-right: 14px;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.LeftDetail-middleContent1 span {
  display: inline-block;
  margin-top: 4px;
  width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
.LeftDetail-middleContent1 p {
  margin-top: 10px;
  font-size: 14px;
  color: #676c71;
}
/* 图片右边的浏览次数 */
.LeftDetail-middleContent2 {
  margin-top: 4px;
  width: 400px;
}
.LeftDetail-middleContent2 p {
  font-size: 12px;
  color: #cbcbcb;
}
.LeftDetail-middleContent2 p span {
  color: #676c71;
}
/* 左边详情的中间 end */

/* 推荐模版 start */
.recommend-mode {
  position: relative;
  height: 25px;
  margin: 30px;
}
.recommend-mode h4 {
  font-size: 16px;
  font-weight: 600;
  color: #eb5139;
}
/* 推荐模版文字下面的横条 */
.recommend-mode strong {
  position: absolute;
  top: 30px;
  left: 8px;
  width: 52px;
  height: 4px;
  background: #eb5139;
}
/* 图片区域 */
.recommend {
  margin-top: 34px;
  height: auto;
}
.recommend li {
  display: flex;
  flex-direction: column;
  width: 155px;
  height: 139px;
  text-align: center;
  cursor: pointer;
}
.recommend li img {
  height: 100%;
}
.recommend li p {
  text-align: center;
  color: #000;
  font-size: 14px;
}
/* 推荐模版 end */

/* 左边详情 end */

/* 右边详情 start */
.information-Rightdetail {
  margin-top: 30px;
  width: 391px;
  height: auto;
  background-color: #fff;
}
/* 右边详情的第一行 start */
.information-Rightdetail-one {
  display: flex;
  padding: 30px;
  height: 50px;
  line-height: 25px;
  border-bottom: 1px solid #f0f0f5;
}
.information-Rightdetail-one img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.information-Rightdetail-nickname h6 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.information-Rightdetail-nickname span {
  font-size: 13px;
  color: #676c71;
}
/* 按钮 */
.information-Rightdetail-one >>> .el-button {
  margin-top: 10px;
  width: 86px;
  height: 30px;
  color: #fff;
  border-radius: 4px 4px 4px 4px;
  border: 0;
}
/* 未关注 */
.information-Rightdetail-one .follow-btn {
  background: #fd4a4d;
}
/* 已关注按钮 */
.information-Rightdetail-one .followed-btn {
  background: #858585;
}
/* 右边详情的第一行 end */

/* 右边详情的第二行 start */
.information-Rightdetail-two {
  width: 391px;
  height: 251px;
  margin-top: 30px;
  border-bottom: 1px solid #f0f0f5;
}
/* 上传积分的信息部分start */
.upload-document-information {
  margin-bottom: 5px;
  margin-left: 20px;
  height: 251px;
}
/* 上传文档积分的图片 */
.upload-document-information img {
  width: 143px;
  height: 109px;
  padding: 20px 30px;
}
/* 上传文档积分的文字 */
.upload-document-information p {
  width: 196px;
  height: 40px;
  font-size: 14px;
  margin-top: 55px;
  color: #333;
  margin-left: -50px;
}
/* 上传文档积分的变色文字 */
.upload-document-information p span {
  color: #ff2222;
}
/* 上传文档积分的按钮 */
.upload-document-points {
  margin-left: -85px;
  margin-bottom: 51px;
  margin-top: 76px;
  width: 137px;
  height: 49px;
  color: #fff;
  border-radius: 8px;
  border: 0;
  background-color: #ff2222;
}
/* 上传积分的信息部分end */
/* 右边详情的第二行 end */

/* 右边详情的第三行 start */
/* .information-Rightdetail-three {
 
} */
/* 课程推荐 */
.hot-courses-information {
  position: relative;
  padding: 26px;
  height: 710px;
  overflow: hidden;
  border-bottom: 1px solid #f0f0f5;
}
.hot-courses-information h4 {
  position: absolute;
  top: 27px;
  left: 27px;
  width: 64px;
  width: 351px;
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
/* 下面的橙色横线 */
.hot-courses-information span {
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 12px;
  width: 65px;
  height: 8px;
  background: #eb5139;
}
/* 右边详情的第三行 end */

/* 右边详情的第四行 start */
/* 会议推荐 */
.hot-search {
  position: relative;
  width: 120px;
  padding: 26px;
  height: 22px;
}
.hot-search-word {
  position: absolute;
  top: 25px;
  left: 26px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
/* 下面的横条 */
.hot-search b {
  display: inline-block;
  width: 65px;
  height: 9px;
  background: #eb5139;
}
.hot-search strong {
  margin-top: 15px;
  display: inline-block;
  width: 65px;
  height: 9px;
  background: #eb5139;
}
/* 右边详情的第四行 end */

/* 右边详情的第五行 start */
.information-Rightdetail-five .latest-upload {
  border: 0;
}
/* 资讯推荐 */
.latest-upload {
  position: relative;
  width: 351px;
  height: auto;
  padding: 0 20px;
  border-bottom: 1px solid #f0f0f5;
}
/* 每一行 */
.latest-upload li {
  margin: 10px 4px;
  width: 315px;
  text-align: center;
  cursor: pointer;
}
/* 小圆点 */
.latest-upload li .point {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #676c71;
}
/* 文字 */
.latest-upload li p {
  width: 280px;
  height: 20px;
  line-height: 15px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #000000;
}

/* 右边详情的第五行 end */

/* 右边详情 end */
</style>